<ax-value-view [label]="item.title || ''" [value]="data" type="TEXT"></ax-value-view>
